import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

import { Preferences } from '@capacitor/preferences';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { Observable, Subject } from 'rxjs';

const THEME_KEY = 'selected-app-theme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    isDarkMode: boolean;
    private themeUpdate$ = new Subject<boolean>();


    constructor(
        private platform: Platform,
    ) {
        this.platform.ready().then(async () => {
            this.setAppTheme(await this.getIsDarkTheme());

            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
            prefersDark.addEventListener('change',
                e => {
                    this.setAppTheme(e.matches);
                }
            );
        });
    }

    async getIsDarkTheme() {
        const theme = await Preferences.get({ key: THEME_KEY });
        return theme.value === 'true' ? true : false;
    }

    toggleAppTheme(isDarkMode) {
        this.isDarkMode = isDarkMode;
        this.setAppTheme(this.isDarkMode);
    }

    async setAppTheme(dark) {
        this.isDarkMode = dark;

        this.isDarkMode
            ? document.body.classList.add('dark')
            : document.body.classList.remove('dark');

        if (Capacitor.isNativePlatform()) {
            await StatusBar.setStyle({ style: this.isDarkMode ? Style.Dark : Style.Light });
        }

        await Preferences.set({
            key: THEME_KEY,
            value: String(this.isDarkMode)
        });

        this.themeUpdate$.next(this.isDarkMode);
    }

    subscribeThemeUpdate(): Observable<boolean> {
        return this.themeUpdate$.asObservable();
    }


}
